import {Component, Injector, Input, OnInit} from "@angular/core";
import {
    AbstractMultiSelectEditControlComponent
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-day-of-week-multi-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(DayOfWeekMultiSelectEditControl),
    ]
})
export class DayOfWeekMultiSelectEditControl extends AbstractMultiSelectEditControlComponent<any> implements OnInit {
    @Input() useDayNameValues: boolean = false;

    constructor(injector: Injector) {
        super(undefined, injector);
    }

    override ngOnInit() {
        this.buildData([
            {label: "wbo.common.dayOfWeek.monday", value: this.useDayNameValues ? "Mon" : "1"},
            {label: "wbo.common.dayOfWeek.tuesday", value: this.useDayNameValues ? "Tue" : "2"},
            {label: "wbo.common.dayOfWeek.wednesday", value: this.useDayNameValues ? "Wed" : "3"},
            {label: "wbo.common.dayOfWeek.thursday", value: this.useDayNameValues ? "Thu" : "4"},
            {label: "wbo.common.dayOfWeek.friday", value: this.useDayNameValues ? "Fri" : "5"},
            {label: "wbo.common.dayOfWeek.saturday", value: this.useDayNameValues ? "Sat" : "6"},
            {label: "wbo.common.dayOfWeek.sunday", value: this.useDayNameValues ? "Sun" : "7"}
        ]);
        super.ngOnInit();
    }
}
